import { auth } from "../../auth/index.js";

//#region src/util/permissions/index.ts
/**
* Check if the account has certain entitlement
*/
function accountHas(entitlement) {
	const session = auth.getCache();
	if (!session) return false;
	return session.features.includes(entitlement);
}
/**
* Check if user is allowed to perform an action
*/
function userCan(...args) {
	const action = args[0];
	const level = args[1];
	const permission = args[2];
	const siteId = level === "site" ? args[3] : void 0;
	const readonlyFactors = typeof args[3] === "object" ? args[3] : typeof args[4] === "object" ? args[4] : void 0;
	const session = auth.getCache();
	if (!session) return false;
	if (readonlyFactors && Object.values(readonlyFactors).some((state) => state === true)) {
		if (action !== "view") return false;
	}
	let allowedActions = [];
	if (level === "account") allowedActions = session.permissions.actions[permission] ?? [];
	if (level === "site") {
		const site = session.sites.find(({ site_id }) => site_id === siteId);
		if (!site) throw new Error("Undefined: site!");
		allowedActions = site.permissions.actions[permission] ?? [];
	}
	return allowedActions.includes(action);
}
/**
* Shorthand for site permissions
*/
userCan.site = (permission, siteId, readonlyFactors) => {
	return {
		canView: userCan("view", "site", permission, siteId, readonlyFactors),
		canCreate: userCan("create", "site", permission, siteId, readonlyFactors),
		canEdit: userCan("edit", "site", permission, siteId, readonlyFactors),
		canDelete: userCan("delete", "site", permission, siteId, readonlyFactors)
	};
};
/**
* Shorthand for account permissions
*/
userCan.account = (permission, readonlyFactors) => {
	return {
		canView: userCan("view", "account", permission, readonlyFactors),
		canCreate: userCan("create", "account", permission, readonlyFactors),
		canEdit: userCan("edit", "account", permission, readonlyFactors),
		canDelete: userCan("delete", "account", permission, readonlyFactors)
	};
};
const permissions = {
	userCan,
	accountHas
};

//#endregion
export { accountHas, permissions, userCan };